import React, { useState, useEffect } from 'react';
import { SubMenuItem } from "./SubMenuItem.jsx"
import { setMenuActive, setMenuActiveId } from './MenuConfig.js';
import { uuid } from '../../item/ItemTools.js';
import { setVal2Token } from '../Login/Auth.js';

function MenuItem({ items, index, Page, checkMenuChange }) {
  const [menuItems, setMenuItems] = useState(items);
  const [page] = useState(Page);
  const [isopen, setOpen] = useState(items.active)
  const [liClass, setLiClass] = useState("")
  const [ulClass, setUlClass] = useState("nav nav-second-level collapse")

  useEffect(() => {
    if (items !== null && items !== menuItems) {
      setMenuItems(items)
      setOpen(items.active)
    }
  }, [items, menuItems])

  useEffect(() => {
    if (isopen) {
      setLiClass("active")
      setUlClass('nav nav-second-level collapse in')
    } else {
      setLiClass("")
      setUlClass('nav nav-second-level collapse')
    }
  }, [isopen])


  function setActivity(menuId) {
    //setOpen(!isopen)
    setMenuActive(menuItems.menuId)
    checkMenuChange()
  }

  function setSelect(parent, child) {
    // console.log(parent)
    // console.log(child)
    setMenuActive(parent.menuId)
    setMenuActiveId(child.menuId)
    var tokenId = uuid(128, 64)
    setVal2Token("url", "", tokenId)
    window.location.assign("/" + child.link + "/" + tokenId);
  }

  var icon = "fa-edit"
  if (menuItems.icon !== undefined)
    icon = menuItems.icon

  //console.log(isopen)
  //console.log(liClass)
  return (
    <li className={liClass} >
      <a href="#A" onClick={e => setActivity()}><i className={"fa " + icon}></i> <span className="nav-label">{menuItems.menuName}</span><span className="fa arrow"></span></a>
      <ul className={ulClass}>
        {/*<SubMenuItem key={"SubMenuItem"+item.menuId} menuItem={item} index={index} Page={page} />*/}
        {
          menuItems.items.map((child, index) => (
            <li key={"SubMenuItem" + child.menuId}>
              <a href="#A" onClick={e => setSelect(menuItems, child)}>{child.menuName}</a>
            </li>
          ))
        }
      </ul>
    </li>
  )
}

export { MenuItem }